//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "FreeCountries",

  emits: ['setActiveCountry'],

  props: {
    countriesList: {
      type: Array,
      default: () => [],
    },

    currentCountry: {
      type: Object,
      default: () => ({})
    }
  },

  methods: {
    setActiveCountry(country) {
      this.$emit('setActiveCountry', country)
    }
  },
}
